export default "__VITE_ASSET__CQjtCfzr__"